/**
 * Transform the highlights resultData, if no resultData available return null.
 * @param  resultData {Object} - the response data.
 * @returns {{smartTextInfo: (Object|null), status: Object, basicInfo: (Object|null)}}
 */
export function marketsResearchHighlightsTransform(resultData) {
    let basicInfo = null;
    let smartTextInfo = null;
    // if the data is null, we must guarantee to create the correct object properties.
    if (resultData.data !== null) {
        basicInfo = resultData.data.basicInfo;
        smartTextInfo = resultData.data.smartTextInfo;
    }
    return {
        status: resultData.status,
        data: {
            basicInfo,
            smartTextInfo
        }
    };
}

/**
 * Transform the bulls vs bears resultData, if no resultData available return null.
 * @param resultData {Object} - the response data.
 * @returns {{bullsSay: (Array|null), bearsSay: (Array|null), status: Object}}
 */
export function marketsResearchBullsVsBearsTransform(resultData) {
    let bullsSay = null;
    let bearsSay = null;
    // if the data is null, we must guarantee to create the correct object properties.
    if (resultData.data !== null) {
        bullsSay = resultData.data.bullsSay;
        bearsSay = resultData.data.bearsSay;
    }
    return {
        status: resultData.status,
        data: {
            bullsSay,
            bearsSay
        }
    };
}
